/**
 * advertorial-sticky-cta.js
 * -------------------------
 * Vanilla JS controller for the mobile-only sticky CTA bar.
 *
 * Behaviour:
 *  - Only activates on screens <= data-breakpoint (default 768px).
 *  - Shows the sticky bar after the user has scrolled past data-threshold %
 *    of the total scrollable page height.
 *  - Hides again when the user scrolls back above the threshold.
 *  - Uses requestAnimationFrame-throttled scroll listener for performance.
 *  - Adds bottom padding to <body> to prevent content overlap.
 *
 * No jQuery. No external dependencies.
 */

(function () {
  'use strict';

  var el = document.getElementById('advStickyCta');
  if (!el) return;

  var threshold = parseInt(el.getAttribute('data-threshold'), 10) || 50;
  var breakpoint = parseInt(el.getAttribute('data-breakpoint'), 10) || 768;

  var isVisible = false;
  var ticking = false;
  var enabled = false;

  /** Check if viewport is at or below breakpoint */
  function isMobile() {
    return window.innerWidth <= breakpoint;
  }

  /** Show the sticky CTA */
  function show() {
    if (isVisible) return;
    isVisible = true;
    el.classList.add('is-visible');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('adv-sticky-active');
  }

  /** Hide the sticky CTA */
  function hide() {
    if (!isVisible) return;
    isVisible = false;
    el.classList.remove('is-visible');
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('adv-sticky-active');
  }

  /** Evaluate scroll position */
  function update() {
    ticking = false;

    if (!enabled) return;

    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var docHeight = document.documentElement.scrollHeight;
    var winHeight = window.innerHeight;
    var scrollable = docHeight - winHeight;

    if (scrollable <= 0) {
      hide();
      return;
    }

    var scrollPercent = (scrollTop / scrollable) * 100;

    if (scrollPercent >= threshold) {
      show();
    } else {
      hide();
    }
  }

  /** rAF-throttled scroll handler */
  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }

  /** Enable or disable based on viewport */
  function handleResize() {
    if (isMobile()) {
      if (!enabled) {
        enabled = true;
        window.addEventListener('scroll', onScroll, { passive: true });
        // Run once to check current position
        update();
      }
    } else {
      if (enabled) {
        enabled = false;
        window.removeEventListener('scroll', onScroll);
        hide();
      }
    }
  }

  /** Debounced resize handler */
  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(handleResize, 100);
  }

  // Initialize
  window.addEventListener('resize', onResize, { passive: true });
  handleResize();
})();
